export default __webpack_public_path__ + "static/media/img-no-config@2x.6955d05a.png";